import { render, staticRenderFns } from "./member_list.vue?vue&type=template&id=981534e4&scoped=true&"
import script from "./member_list.vue?vue&type=script&lang=tsx&"
export * from "./member_list.vue?vue&type=script&lang=tsx&"
import style0 from "./member_list.vue?vue&type=style&index=0&id=981534e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981534e4",
  null
  
)

export default component.exports